/**
 * Sophia Platform (Cloudflare Edge-Native Edition)
 *
 * @file        Admin Shell Master Layout (Task 11.1.3 / Task 11.1.4)
 * @author      Le Viet Quang <quangle@fourelementscorp.com>
 * @copyright   (c) 2026 Le Viet Quang / Four Elements Corp
 * @license     MIT
 */

import React from 'react';
import { AdminSidebar, type AdminViewId } from './AdminSidebar';
import { AdminHeader } from './AdminHeader';

export interface AdminLayoutProps {
  activeView: AdminViewId;
  onViewChange: (view: AdminViewId) => void;
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({
  activeView,
  onViewChange,
  children,
}) => {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-background-base text-foreground font-sans">
      {/* Fixed Sidebar */}
      <AdminSidebar activeView={activeView} onViewChange={onViewChange} />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <AdminHeader activeView={activeView} />

        <main className="flex-1 overflow-y-auto p-6">
          <div className="max-w-7xl mx-auto space-y-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
